export enum TrainingDay {
  Monday = "l",
  Thuesday = "m",
  Wednesday = "x",
  Thursday = "j",
  Friday = "v",
  Saturday = "s",
  Sunday = "d",
}


export const dayNames: Record<TrainingDay, string> = {
  l: "Lunes",
  m: "Martes",
  x: "Miércoles",
  j: "Jueves",
  v: "Viernes",
  s: "Sábado",
  d: "Domingo",
};